module.exports = __webpack_public_path__ + "assets/media/arrow-about.c3b4c23c.svg";